// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
// 自定义插入开始
import Vuex from 'vuex'

Vue.use(Vuex)

import global_ from './Global.vue'
Vue.prototype.GLOBAL = global_;

// 引入ajax组件
import axios from 'axios';

// http request 请求拦截器，有token值则配置上token值

// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
axios.interceptors.response.use(
    response => {
    if (response.data.code) {
    switch (response.data.code) {
        case -1:
            // 店铺未授权
            router.replace({
                path: '/intercept',
                query: {
                    redirect: router.currentRoute.fullPath,
                    msg: response.data.msg
                }   //登录成功后跳入浏览的当前页面
            });
            break;
        case -2:
            // 微信未授权
            router.replace({
                path: '/login',
                query: {
                    redirect: global_.HOME_URL+router.currentRoute.fullPath,
                    serverUrl: global_.AUTH_URL
                }   //将当前页面发送给后端
            })
    }
}
return response;
}
);

axios.defaults.baseURL=global_.BASE_URL;

Vue.prototype.axios = axios;

const states = {
    orderListScrollTop: 0
}

const store = new Vuex.Store({
    state: states,
    mutations: {
        updateOrderListScrollTopPosition (state, payload) {
            // console.log(document.querySelector('#orderContainer'))
            //console.log(document.getElementById('vux_view_box_body').scrollTop)
            state.orderListScrollTop = payload.top
            // console.log(state)
        }
    }
})

// import '../font-awesome-4.7.0/css/font-awesome.min.css'
import 'font-awesome/css/font-awesome.css'

// 自定义插入结束
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js